import { render, staticRenderFns } from "./PhonesGridHeadline.vue?vue&type=template&id=474f80a8"
import script from "./PhonesGridHeadline.vue?vue&type=script&lang=ts"
export * from "./PhonesGridHeadline.vue?vue&type=script&lang=ts"
import style0 from "./PhonesGridHeadline.vue?vue&type=style&index=0&id=474f80a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports